export const shouldRefreshBalanceFromSseMessage = message => {
  if (!message || typeof message !== 'object') return false;
  if (message.error) return false;
  if (message.t === 0 || message.t === -1) return false;
  if (typeof message.t === 'undefined') return false;
  return true;
};

export const shouldPollGameDetailBalance = ({
  isLoggedIn,
  isDemoUrl,
  isWebView,
  isSuspendedLogoutModalOpen,
  isBalanceSSEEnabled
} = {}) => (
  Boolean(isLoggedIn)
  && !isDemoUrl
  && !isWebView
  && !isSuspendedLogoutModalOpen
  && !isBalanceSSEEnabled
);

export const shouldRefreshBalanceOnBetSlipOpen = ({
  isAuthenticated,
  isBalanceSSEEnabled
} = {}) => Boolean(isAuthenticated) && !isBalanceSSEEnabled;
